import __i18n from "../intl/__i18n";



export const enum PaymentType {
  "Purchase" = "purchase",
  "Subscription" = "subscription",
  "CreditWallet" = "credit_wallet",
}


export const PaymentTypeOptions = [{
  value: PaymentType.Purchase,
  label: __i18n("Single Purchase")
}, {
  value: PaymentType.Subscription,
  label: __i18n("Subscription")
}, {
  value: PaymentType.CreditWallet,
  label: __i18n("Credit Wallet")
}];



